import { render } from "./InputSelectList.vue?vue&type=template&id=720cd5b5"
import script from "./InputSelectList.vue?vue&type=script&lang=js"
export * from "./InputSelectList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WEB\\LICEO\\CURSOS\\portalalumnoscursos\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__